import { render, staticRenderFns } from "./ProgramsSingle.vue?vue&type=template&id=27429bbd&"
import script from "./ProgramsSingle.vue?vue&type=script&lang=js&"
export * from "./ProgramsSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports